<!-- /FourthSection/ -->
<template>
    <div class="FourthSectionContainer">
        <div class="leftBox">
            <img class="leftBoxImage" :src="image" alt="image">
        </div>
        <div class="rightBox">
            <h1 class="title">
                Vous etes courtier indépendant ou vous managez un réseau, une équipe ou un groupe de courtiers ?
            </h1>
            <div class="detail">
                <p>
                    Inscrivez-vous sur la plateforme et un conseiller Prexange prendra contact avec vous et complètera
                    votre inscription
                </p>
                <ul>
                    <li>
                        <a href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" class="text" target="_blank" style="text-decoration: none;">Inscription gratuite</a>
                    </li>
            
                    <li>
                        Echange personnalisé avec un Expert Prexange
                    </li>
                    <li>
                        Nous revenons vers vous avec une recommandation personnalisée
                    </li>
                    <li>
                        Publiez vos premiers dossiers sur Prexange
                    </li>
                </ul>
            </div>
            <button class="signInBtn">
                <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
                <a href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" class="text" target="_blank" style="color: white; text-decoration: none;"><span>Demande d’inscription </span></a>
            </button>
        </div>
    </div>
</template>

<script>

import image from '@/assets/images/FourthSectionimg.png';

export default {
    name: 'FourthSection',
    data() {
        return {
            image: image,
            isSidebarOpen: false,
        };
    },
};
</script>


<style lang="scss">
@import './FourthSection.scss'
</style>